<usucampeao-accordion titulo="Endereço" [estaAberto]="accordionEstaAberto"
  (aoAlterarAberturaAccordion)="alterarAberturaAccordion($event)">
  <usucampeao-status-preenchimento extras [status]="statusPreenchimento"></usucampeao-status-preenchimento>

  <form [formGroup]="form">
    <usucampeao-endereco-form #enderecoForm [readonly]="formDesabilitado"></usucampeao-endereco-form>
    <ion-button mode="md" (click)="submit()">Salvar e continuar</ion-button>
  </form>
</usucampeao-accordion>
